module.exports = __webpack_public_path__ + "img/square.b8e3dfc.png?v=1791296779994";